var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaymentGateway(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -1.084,
    y1: 1.322,
    x2: 0.211,
    y2: 1.959,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff5e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605,
    stopColor: "#7d95e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3f28dd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Payment_gateway",
    "data-name": "Payment gateway",
    transform: "translate(-760 -55)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6094",
    "data-name": "Rectangle 6094",
    width: 24,
    height: 24,
    transform: "translate(760 55)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Payment_Gateway-2",
    "data-name": "Payment Gateway",
    transform: "translate(761.2 57.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1932",
    "data-name": "Path 1932",
    d: "M21.912,13.906V6.2a2.9,2.9,0,0,0-2.9-2.9H4.2A2.9,2.9,0,0,0,1.3,6.2l-.1,7.7Z",
    transform: "translate(-1.2 -3.3)",
    fill: "#18253e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_184",
    "data-name": "Ellipse 184",
    cx: 6.404,
    cy: 6.404,
    r: 6.404,
    transform: "translate(8.905 2.501)",
    fill: "#33eeb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1933",
    "data-name": "Path 1933",
    d: "M17.3,11H14.2a.43.43,0,0,1-.4-.4.367.367,0,0,1,.4-.4h3.1c0-.1-.1-.2-.1-.3A1.509,1.509,0,0,0,15.8,9H14.3a.759.759,0,0,1-.4-.2c-.2-.2,0-.6.3-.6h4.5a.367.367,0,0,1,.4.4c.1.3-.1.4-.4.4H17.6a5.362,5.362,0,0,1,.5,1.1h.6a.458.458,0,0,1,.5.4.43.43,0,0,1-.4.4h-.6a2.429,2.429,0,0,1-2.9,1.9l.2.2c.8.8,1.6,1.5,2.4,2.3l.2.2a.447.447,0,0,1,0,.5.33.33,0,0,1-.5,0c-.1,0-.1-.1-.2-.1-1.1-1-2.2-2.1-3.2-3.1-.2-.2-.3-.3-.2-.6.1-.2.3-.2.5-.2H16C16.5,12.1,17.1,11.6,17.3,11Z",
    transform: "translate(-1.193 -3.297)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1934",
    "data-name": "Path 1934",
    d: "M2.7,16.708a2.826,2.826,0,0,1-1.5-2.5v-8A2.9,2.9,0,0,1,4.1,3.3l9.505,4.8c3.4,1.5,2.9,2.9,2.9,4.5v8a1.893,1.893,0,0,1-2.7,1.7Z",
    transform: "translate(-1.2 -3.3)",
    fill: "url(#linear-gradient)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentGateway);
export default __webpack_public_path__ + "static/media/payment_gateway.51838330e63f604bada3a505807d7287.svg";
export { ForwardRef as ReactComponent };